import { TriangleDownIcon } from "../../Icons"
import { styled, StyleProps } from "../../styles"

const StyledIcon = styled(TriangleDownIcon)((props: StyleProps) => ({
  marginLeft: props.theme.spacing(3),
  color: `hsla(0, 0%, 0%, .6)`,
}))

export default StyledIcon
